import React,{useEffect,useState,useRef} from "react";
import JoditEditor from 'jodit-react'
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import articleService from '../../../services/articles.service'

export default function AddArticles() {
    const [content,setContent] = useState()
    const [category,setCategory] = useState([])
    const editor = useRef(null)
    const config = {
        readonly:false,
        height:"80vh",
       
        disablePlugins: ['powered-by-jodit','file'],
          }
    const {
            register,
            handleSubmit,
            setValue,
            formState: { errors },
          } = useForm();

    useEffect(()=>{
        //get category list
        articleService.getArticlesCategory()
        .then(res=>{
            setCategory(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    },[])
    const onSubmit = (data)=>{
        const newData = {...data,content:content};
        articleService.saveArticles(newData)
        .then(res=>{
            toast.success("Article Saved",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })
        .catch(err=>{
            toast.error("Error while adding Article",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            console.log(err)
        })
    }
    return (
    <>
      <div className="pagetitle d-flex justify-content-between">
        <h1>New Article</h1>
        <div>
          

          <Link to="/articles" className="btn btn-sm btn-secondary">
            Cancel
          </Link>
        </div>
      </div>
    <div className="container mt-4">
        <div className="row">
            <div className="col-8"  style={{height:"100vh"}}>
            <JoditEditor 
                ref={editor} 
                value={content} 
                onChange={(newContent)=>{}}
                onBlur={newContent => setContent(newContent)}
                config={config}
                tabIndex = {1}
            />
            </div>
            <div className="col-4">
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="d-flex justify-content-end mt-3">
                                <button type="submit" className="btn btn-success btn-sm"> <i className="bi bi-floppy-fill"></i> Save Article</button>
                            </div>
                            <div className="form-group mt-3">
                                <label htmlFor="" className="form-label">Title<span className="text-danger"><sup>*</sup></span></label>
                                <input type="text" {...register("title",{required:true})} className="form-control" />
                                {errors.title && <div className="text-danger">Title is required</div>}
                            </div>
                            <div className="form-group mt-3">
                                <label htmlFor="" className="form-label">Status</label>
                                <select {...register("status")} className="form-select">
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                            </div>
                            <div className="form-group mt-3">
                                <label htmlFor="" className="form-label">Category</label>
                                <select {...register("articleCategoryId")} className="form-select">
                                    {category && category.map((item,index)=>(
                                        <option key={index} value={item.id}>{item.title}</option>
                                    ))}
                                
                                </select>
                            </div>
                            <div className="form-group mt-3">
                                <label htmlFor="" className="form-label">Summary</label>
                                <textarea className="form-control" {...register("summary")} cols="30" rows="4"></textarea>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  );
}
